import { useSelector, TypedUseSelectorHook } from "react-redux";
import { IRootState } from "../types";

export const useTypedSelector: TypedUseSelectorHook<IRootState> = useSelector;
